import system from './system';

// loading app routes
import meeting from './meeting'
import contact from './contact'
import segment from './segment'
import user from './user'

import utility from './utility'
import config from './config'
import uiConfig from './ui-config'
import page from './page'
import userPreference from './user-preference'
import activity from './activity'
import chat from './chat'

import site from './site'

export default [
    {
        path: 'dashboard',
        name: 'appDashboard',
        meta: {
            title: 'dashboard.dashboard',
            description: '',
            icon: 'fas fa-home',
        },
        components: {
            header:  () => import('@views/app/dashboard/header.vue'),
            special:  () => import('@views/app/dashboard/index.vue'),
        },
    },
    {
        path: '',
        meta: {
            isHiddenNav: true,
        },
        components: {
            header:  () => import('@views/layouts/partials/app-common-page-header.vue'),
            default: { template: '<router-view></router-view>' },
        },
        children: [
            ...system,

            ...meeting,
            ...segment,
            ...contact,
            ...user,

            ...utility,
            ...config,
            ...uiConfig,
            ...page,
            ...userPreference,
            ...activity,
            ...chat,

            ...site,
        ]
    },
]
